import {
  Button,
  Checkbox,
  FormHelperText,
  MenuItem,
  Select,
  TextField,
  SelectChangeEvent,
  ListItemText,
} from '@mui/material';
import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import * as Yup from 'yup';

import { errorToast, successToast } from '../../helpers';
import MainContainer from '../../layout/MainContainer';
import { useLazyGetMasterDataQuery } from '../../service/common';
import {
  useAddPromoCodeMutation,
  useLazyGetPromoCodeByIdQuery,
  useAddDealerDropdownForPromoMutation,
} from '../../service/promoCode';
import { CommonBody, MasterData } from '../../types/General';
import { generateEncryptedKeyBody } from '../../utils/crypto';
import { DISCOUNT_TYPE, USER_TYPE } from '../../utils/enums';
const icon = (
  <span
    style={{
      display: 'block',
      width: 16,
      height: 16,
      border: '1px solid #ed5f00',
    }}
  />
);
const checkedIcon = (
  <span
    style={{
      display: 'block',
      width: 16,
      height: 16,
      backgroundColor: '#ed5f00',
    }}
  />
);

const AddPromoCode = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [selectedUsers, setSelectedUsers] = useState<any>([]);
  const [masterData, setMasterData] = useState<MasterData>();

  const [addPromo] = useAddPromoCodeMutation();
  const [addDealerDropdownForPromo] = useAddDealerDropdownForPromoMutation();
  const [getMasterData] = useLazyGetMasterDataQuery();
  const [getPromoById] = useLazyGetPromoCodeByIdQuery();
  const [data, setData] = useState<any>({});

  const fetchPromoById = async (id: string) => {
    try {
      const res = await getPromoById({ id }).unwrap();
      if (res?.statusCode === 200) {
        fetchPromoDropSown(id);
        setData(res?.data);
      }
    } catch (error: any) {
      console.error(error);
    }
  };

  const fetchPromoDropSown = async (id: string) => {
    try {
      const body = {
        promoId: id,
      };
      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
      const res = await addDealerDropdownForPromo({
        body: encryptedBody,
      }).unwrap();
      if (res?.statusCode === 200) {
        formik.setFieldValue(
          'sellerId',
          res?.data
            ?.filter((data: { isAssigned: boolean }) => data.isAssigned)
            .map((data: { _id: string }) => data._id)
        );
      }
    } catch (error: any) {
      console.error(error);
      errorToast(error?.data?.message);
    }
  };

  const formSchema = Yup.object({
    name: Yup.string().required('Name is required'),
    discount: Yup.string().required('Discount is required'),
    // userType: Yup.string().required("User Type is required"),
    // sellerId: Yup.string().required("This field is required"),
    type: Yup.string().required('This field is required'),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: data?.name,
      discount: data?.discountPrice,
      sellerId: [],
      type: data?.type ?? 77,
    },
    validationSchema: formSchema,
    onSubmit: async (values: any) => {
      try {
        const body = {
          name: values.name,
          discountPrice: values.discount,
          users: values.sellerId,
          type: values.type,
        };
        const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
        const res = await addPromo({ body: encryptedBody }).unwrap();
        if (res?.statusCode === 200) {
          successToast('Promo code added');
          navigate('/manage-promo-codes');
        }
      } catch (error: any) {
        console.error(error);
        errorToast(error?.data?.message);
      }
    },
  });

  const fetchMasterData = async (userType: number) => {
    // setLoading(true);
    try {
      const res = await getMasterData({
        search: 'userType',
        ...(userType ? { role: Number(userType) } : {}),
      }).unwrap();
      if (res?.statusCode === 200) {
        setMasterData(res?.data);
        // setLoading(false);
      }
    } catch (error: any) {
      console.error(error);
      // setLoading(false);
    }
  };

  // const handleSellerChange = (event: SelectChangeEvent) => {
  //   formik.setFieldValue("sellerId", event.target.value);
  // };

  const handleSellerChange = (event: SelectChangeEvent) => {
    const selectedSellers = event.target.value;
    formik.setFieldValue('sellerId', selectedSellers);
  };

  useEffect(() => {
    // if (formik.values.userType) {
    fetchMasterData(USER_TYPE.DEALER);
    // }
  }, []);

  useEffect(() => {
    if (id) {
      fetchPromoById(id);
    }
  }, [id]);

  return (
    <MainContainer>
      <div className="main_title fdx">
        <div>
          <h1>{id ? 'Edit' : 'Add'} Promo Code</h1>
          <p>
            <span onClick={() => navigate('/dashboard')}>Dashboard</span> -{' '}
            <span onClick={() => navigate('/manage-promo-codes')}>Promo Codes</span> -{' '}
            {id ? 'Edit' : 'Add'} Promo Code{' '}
          </p>
        </div>
        <div className="right_s align_right">
          <Button className="btn btn_orange" onClick={() => navigate(-1)}>
            Back
          </Button>
        </div>
      </div>

      <div className="cards">
        <form className="form" onSubmit={formik.handleSubmit} action="">
          <div className="gap_p">
            <div className="control_group w_50">
              <label>Promo Code Name</label>
              <TextField
                className="text_field"
                variant="outlined"
                placeholder="Promo Code Name"
                fullWidth
                hiddenLabel
                name="name"
                value={formik.values.name}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                helperText={formik.touched.name && formik.errors.name}

                // value={fullName}
                // onChange={(e) => setFullName(e.target.value)}
              />
              {/* {error && fullName == "" ? (
                <h6 className="err_msg">Name is required</h6>
              ) : (
                ""
              )} */}
            </div>
            <div className="control_group w_50">
              <label>Discount</label>
              <TextField
                className="text_field"
                variant="outlined"
                placeholder="Discount"
                fullWidth
                hiddenLabel
                name="discount"
                value={formik.values.discount}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                helperText={formik.touched.discount && formik.errors.discount}
                // value={fullName}
                // onChange={(e) => setFullName(e.target.value)}
              />
              {/* {error && fullName == "" ? (
                <h6 className="err_msg">Name is required</h6>
              ) : (
                ""
              )} */}
            </div>
            <div className="control_group w_50">
              <label>Select Discount Type</label>
              <Select
                fullWidth
                id="type"
                name="type"
                value={formik.values.type}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.type && Boolean(formik.errors.type)}
                displayEmpty
              >
                <MenuItem disabled value={77}>
                  Select Discount Type
                </MenuItem>
                <MenuItem value={DISCOUNT_TYPE.FLAT}>Flat</MenuItem>
                <MenuItem value={DISCOUNT_TYPE.PERCENT}>Percent</MenuItem>
              </Select>
              <FormHelperText error>
                {formik.touched.type && typeof formik.errors.type === 'string'
                  ? formik.errors.type
                  : ''}
              </FormHelperText>
            </div>
            {/* <div className="control_group w_50">
              <label>Select User Type</label>
              <Select
                fullWidth
                id="userType"
                name="userType"
                value={formik.values.userType}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.userType && Boolean(formik.errors.userType)
                }
                displayEmpty
              >
                <MenuItem disabled value="">
                  Select User Type
                </MenuItem>
                <MenuItem value={USER_TYPE.INDIVIDUAL}>Individual</MenuItem>
                <MenuItem value={USER_TYPE.DEALER}>Dealer</MenuItem>
              </Select>
              <FormHelperText error>
                {formik.touched.userType &&
                typeof formik.errors.userType === "string"
                  ? formik.errors.userType
                  : ""}
              </FormHelperText>
            </div> */}

            <div className="control_group w_50">
              <label>Select Sellers</label>
              <Select
                fullWidth
                labelId="seller"
                id="seller"
                name="sellerId"
                value={formik.values.sellerId || []}
                onChange={handleSellerChange}
                error={formik.touched.sellerId && Boolean(formik.errors.sellerId)}
                displayEmpty
                multiple
                renderValue={(selected: any) => {
                  if (selected.length === 0) {
                    return <em>Select Sellers</em>;
                  }

                  return (selected as string[])
                    .map((value) => {
                      const selectedUser = masterData?.user?.find((item) => item._id === value);
                      return selectedUser ? selectedUser.name : '';
                    })
                    .filter((name) => name)
                    .join(', ');
                }}
              >
                <MenuItem disabled value="0">
                  Select Sellers
                </MenuItem>
                {masterData?.user?.length ? (
                  masterData?.user?.map((item) => (
                    <MenuItem value={item?._id} key={item?._id}>
                      <Checkbox
                        style={{ marginRight: '10px' }}
                        checked={formik.values.sellerId.includes(item?._id)}
                      />
                      <ListItemText primary={item?.name} />
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled value={1}>
                    No user found
                  </MenuItem>
                )}
              </Select>
              <FormHelperText error>
                {formik.touched.sellerId && formik.errors.sellerId}
              </FormHelperText>
            </div>
            {/* <div className="control_group w_100">
              <label>Blog Description</label>
              <EditText content={description} setContent={setDescription} />
            </div> */}
          </div>

          <div className="form_end_btn" style={{ marginTop: '20px' }}>
            <Button className="btn btn_secondary" type="submit">
              Submit
            </Button>
          </div>
        </form>
      </div>
    </MainContainer>
  );
};

export default AddPromoCode;
